<dx-popup class="popup" [showTitle]="true" [title]="'Dateien werden hochgeladen'" [dragEnabled]="false"
  [height]="'auto'" [width]="'auto'" [hideOnOutsideClick]="false" [(visible)]="popupVisible">
  <div *dxTemplate="let data of 'content'">

    <h1 class="uploadh1">{{isUploaded}} von {{toUpload}} hochgeladen</h1>
    <h4>{{uploadFileName}}</h4>
    <div class="upload-loading">
      <div class="osahanloading"></div>
    </div>
  </div>


  <dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom"
    [options]="{ text: 'Abbrechen', onClick: onClickClose }">
  </dxi-popup-toolbar-item>
</dx-popup>
